export default {
  formContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'left',
  },
  formTitle: {
    textAlign: 'center',
  },
};
